import { Formik, getIn } from "formik";
import { Button, Card, Col, Row, Spinner } from "reactstrap";
import { validationSchema } from "../../../validations/transporter.validation";
import {
  addTransporter,
  getTransporter,
  updateTransporter,
} from "../../../services/transporters.service";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import QueryString from "qs";
import { toast } from "react-hot-toast";
import FormSelect from "../../../components/FormSelect";
import { getStates } from "../../../services/state.service";
import { getCities } from "../../../services/city.service";
import FormInput from "../../../components/FormInput";
import { useEffect, useState } from "react";

// interface InitialValues {
//   name: string;
//   gst: string;
//   state: object | undefined;
//   city: object | undefined;
//   mobile: string;
//   workingCity: string[];
//   address: string;
//   status: boolean;
// }

let initialValues: any = {
  name: "",
  gst: "",
  state: undefined,
  city: undefined,
  mobile: "",
  workingCity: [],
  address: "",
  status: true,
};

export default function Form() {
  const location = useLocation();
  const navigate = useNavigate();
  const params: any = useParams();
  const [initialValuesData, setInitialValuesData] = useState(initialValues);
  const [loader, setLoader] = useState(true);
  const query: any = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    if (params.id) {
      getTransporter(params.id)
        .then((response) => {
          const transporterData = response.data;

          // Update the initialValues object with the received data
          const updatedInitialValues = {
            ...initialValues,
            name: transporterData.name || "",
            gst: transporterData.gst || "",
            state: transporterData.state || undefined,
            city: transporterData.city || undefined,
            mobileNumber: transporterData.mobileNumber || "",
            workingCity: transporterData.workingCity || [],
            address: transporterData.address || "",
            status: transporterData.status || true,
          };

          setInitialValuesData(updatedInitialValues);
          setLoader(false);
        })
        .catch((error) => {
          // Handle error if API call fails
          toast.error(`Error fetching transporter data: ${JSON.stringify(error)}`);
        });
    } else {
      setLoader(false);
    }
  }, [params.id]);

  function handleSubmit(values: any, actions: any) {
    const updatedData = {
      ...values,
      city: values.city.id,
      state: values.state.id,
      workingCity: values.workingCity.map((city: any) => city.id),
    };
    if (params.id) {
      updateTransporter(params.id, updatedData)
        .then((response) => {
          toast.success(response.data.message);
          navigate(query.redirect);
        })
        .catch(() => {
          actions.setSubmitting(false);
        });
    } else {
      addTransporter(updatedData)
        .then((response) => {
          toast.success(response.data.message);
          navigate(query.redirect);
        })
        .catch(() => {
          actions.setSubmitting(false);
        });
    }
  }

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      {loader ? (
        <Spinner />
      ) : (
        <Formik
          initialValues={initialValuesData}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleBlur, handleChange, setFieldValue, handleSubmit }) => (
            <>
              <Row className='align-items-center mb-2 page-title-row'>
                <Col sm>
                  <h1 className='my-1 fw-bold h4'>Transporter Master</h1>
                </Col>
                <Col sm='auto'>
                  <div className='justify-content-between'>
                    <Button
                      size='sm'
                      color='secondary'
                      className='my-1 me-2 fw-semibold'
                      style={{ opacity: 1 }}
                      onClick={() => {
                        navigate(query.redirect);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size='sm'
                      color='primary'
                      className='my-1 text-white'
                      onClick={() => handleSubmit()}
                    >
                      Submit
                    </Button>
                  </div>
                </Col>
              </Row>
              <div className='flex-grow-1 overflow-auto'>
                <Card className='h-100 p-3 w-100 '>
                  <Col md={8}>
                    <div className='d-flex flex-column h-100 rounded-0'>
                      <form onSubmit={handleSubmit}>
                        <Row>
                          <Col md={6}>
                            <FormInput
                              name='name'
                              label='FullName'
                              placeholder='FullName'
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                              error={errors.name}
                              touched={touched.name}
                            />
                          </Col>
                          <Col md={6}>
                            <FormInput
                              name='gst'
                              label='GST'
                              placeholder='GST'
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.gst}
                              error={errors.gst}
                              touched={touched.gst}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormSelect
                              id='state'
                              name='state'
                              label='State'
                              placeholder='State'
                              isAsync
                              getOptions={getStates}
                              onChange={(name: any, value: any) => {
                                setFieldValue(name, value);
                                setFieldValue("city", "");
                              }}
                              onBlur={handleBlur}
                              value={getIn(values, "state")}
                              error={getIn(errors, "state")}
                              touched={getIn(touched, "state")}
                            />
                          </Col>
                          <Col md={6}>
                            <FormSelect
                              id='city'
                              key={values.state?.id || ""}
                              name='city'
                              label='City'
                              placeholder='City'
                              isAsync
                              getOptions={getCities}
                              defaultFilter={{ state: values.state?.id || "" }}
                              onChange={(name: any, value: any) => {
                                setFieldValue(name, value);
                              }}
                              onBlur={handleBlur}
                              value={getIn(values, "city")}
                              error={getIn(errors, "city")}
                              touched={getIn(touched, "city")}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormInput
                              name='mobileNumber'
                              label='Mobile No.'
                              placeholder='Mobile No.'
                              type='number'
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.mobileNumber}
                              error={errors.mobileNumber}
                              touched={touched.mobileNumber}
                            />
                          </Col>
                          <Col md={6}>
                            <FormSelect
                              id='workingCity'
                              name='workingCity'
                              label='Working City'
                              placeholder='Working City'
                              isMulti
                              isAsync
                              getOptions={getCities}
                              onChange={(name: any, value: any) => {
                                setFieldValue(name, value);
                              }}
                              onBlur={handleBlur}
                              value={getIn(values, "workingCity")}
                              error={getIn(errors, "workingCity")}
                              touched={getIn(touched, "workingCity")}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <FormInput
                              name='address'
                              label='Address'
                              type='textarea'
                              placeholder='Address'
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address}
                              error={errors.address}
                              touched={touched.address}
                            />
                          </Col>
                        </Row>
                      </form>
                    </div>
                  </Col>
                </Card>
              </div>
            </>
          )}
        </Formik>
      )}
    </div>
  );
}
